import { h } from 'preact';
import { Text } from 'preact-i18n';

// Legend for the menu text colours (hamburger menu + left sidebar):
// body colour = every user, amber = unlocked by a role (isRoleLink), red = super admins (hasToBeAdmin/adminOnly).
const DOT_STYLE = 'display: inline-block; width: 9px; height: 9px; border-radius: 50%; margin-right: 5px;';

const DOTS = [
    { key: 'all', color: 'var(--bs-body-color)', label: <Text id='menu.legend-all'>All users</Text> },
    { key: 'role', color: 'var(--bs-warning)', label: <Text id='menu.legend-role'>Users with a role</Text> },
    { key: 'admin', color: 'var(--bs-danger)', label: <Text id='menu.legend-admin'>Super admins only</Text> },
];

function MenuColorLegend({ class: className = '' }) {
    return (
        <div class={`d-flex flex-wrap justify-content-center align-items-center gap-3 text-body-secondary ${className}`} data-menu-legend>
            {DOTS.map(dot => (
                <small key={dot.key} class='d-flex align-items-center'>
                    <span style={`${DOT_STYLE} background-color: ${dot.color};`} />
                    {dot.label}
                </small>
            ))}
        </div>
    );
}

export default MenuColorLegend;
